import { get, put, post } from "./ServerHelper";

export default {
  applicationsQuery(params) {
    return get("/applications", { params });
  },
  applicationsGetOne(id) {
    return get(`/applications/${id}`);
  },
  applicationsUpdate(app) {
    return put(`/applications/${app.appId}`, app);
  },
  applicationsCounts(params) {
    return get("/application_counts", { params });
  },
  applicationsPeople(id) {
    return get(`/applications/${id}/people`);
  },
  applicationsHistory(id) {
    return get(`/applications/${id}/history`);
  },
  applicationsImages(id) {
    return get(`/applications/${id}/images`);
  },
  applicationsImagesUpdate(id, images) {
    return put(`/applications/${id}/images`, images);
  },
  applicationsImagePyramid(id, key) {
    return get(`/applications/${id}/images/${key}`);
  },
  applicationsImagePDF(id, range) {
    return get(`/applications/${id}/pdf`, { params: { range } });
  },
  imagePostRequest(id, contentType) {
    return post(`/applications/${id}/images`, { contentType });
  }
};
